var _path, _path2, _path3, _path4, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 12.1245V46.9605H49.2514V12.1245H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M33.1738 24.9365L27.4595 23.3291L26.7399 25.8383L28.6873 26.3824L21.6806 31.1778L20.4981 29.4247C20.2925 29.1198 19.9982 28.9302 19.6791 28.8681C19.36 28.8061 18.9842 28.8655 18.7112 29.0774L6.7576 37.6692L8.22286 39.8415L19.1094 31.9695L20.2919 33.7226C20.7032 34.3324 21.5009 34.4874 22.1107 34.0761L30.1525 28.5548L29.9275 30.5641L32.5236 30.837L33.1738 24.9365Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M5.91016 21.7004V39.9037C5.91016 40.6189 6.49526 41.204 7.21039 41.204H43.4607V38.6035H8.51063V21.7004H5.91016Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.2514 10.0221V2.68408H0V10.0221H49.2514Z",
    opacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.433,
    cy: 6.483,
    r: 1.478,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.358,
    cy: 6.483,
    r: 1.478,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.40f6ac17c49193ba5dc91847255d4613.svg";
export { ForwardRef as ReactComponent };